import {getQueryString} from './../Common/Utils';
//TODO:- file for each utility function 
export function formatString(str: String) {
  return str.replace(/[(//:,^+*=)]/g, '');
}


/**This function check whether the val is present in arr or not if present then remove from arr and if not then push into arr */
export function addRemoveArrayOperation(arr:any[],val:any){
  const index = arr.indexOf(val);
  if (index === -1) {
    arr.push(val);
  } else {
    arr.splice(index, 1);
  }
  return arr;  
}
export function isFilterEmpty(filters:any){
  let isEmpty= true;
if(filters && Object.keys(filters).length){
  Object.keys(filters).forEach(type => {
    if(Array.isArray(filters[type])){
      if(filters[type].length){
        isEmpty= false;
      }
    }
    else if(type==='single_seat' && filters[type] === true){
      isEmpty = false
    }
    else{
      if(Object.keys(filters[type]).length){
        isEmpty = false
      }
    }
   
  });
}
return isEmpty;
}
// that will return pattern;
export function getFilterRegEx(selectedFilters:any,popularFilters:any) {
  let popularRegEx = '';
  let busTypeRegEx = '';
  let departureTimeRegEx = '';
  let arrivalTimeRegEx = '';
  let bpRegEx = '';
  let dpRegEx = '';
  let operatorRegEx = '';
  let amenitiesRegEx = '';
  let singleSeatRegEx = '';
  const defaultRegEx=".*?:"
  // popular: [],
  //   busType: [],
  //   departureTime: [],
  //   arrivalTime: [],
  //   boardingPoint: [],
  //   droppingPoint: [],
  //   operator: [],
  //   amenities: [],
  
/**
 * /popular:(ac|nonac):(seater|sleeper)/
 *  */   
const isPopularFilterSelected =  selectedFilters && selectedFilters.popular && selectedFilters.popular.length
 if(popularFilters && popularFilters.length ){
  for(let i in popularFilters){
    if(isPopularFilterSelected && selectedFilters.popular.indexOf(popularFilters[i].k)!== -1){
      popularRegEx += `.*${popularFilters[i].k}.*:`

    }else{
      popularRegEx += defaultRegEx;

    }
  }
 }
 if(selectedFilters){
  // if(selectedFilters.popular.length){
  // popularRegEx = `.*${selectedFilters.popular.join("|")}.*:`;
  // }else{
  //   //default condition
  //   popularRegEx = defaultRegEx;
  // }

  if(selectedFilters.busType.length){
    const ac = (selectedFilters.busType.indexOf('ac') > -1);
    const nonac = (selectedFilters.busType.indexOf('nonac') > -1);
    const seater = (selectedFilters.busType.indexOf('seater') > -1);
    const sleeper = (selectedFilters.busType.indexOf('sleeper') > -1);
        if(ac && nonac){
          busTypeRegEx += '(ac|nonac):'
        }
        else if(!ac && !nonac){
          busTypeRegEx += defaultRegEx;
        }
        else{
          busTypeRegEx+=`${ac ? 'ac:' :''}${nonac ? 'nonac:' :''}`
        }
        if(seater && sleeper){
          busTypeRegEx += '.*(seater|sleeper).*:'
        }
        else if(!seater && !sleeper){
          busTypeRegEx += defaultRegEx;
        }
        else{
          busTypeRegEx +=`${seater ? '.*seater.*:' :''}${sleeper ? '.*sleeper.*:' :''}`
        }
    }else{
      //default condition
      busTypeRegEx = defaultRegEx + defaultRegEx;

    }
    if(selectedFilters.operator && Object.keys(selectedFilters.operator).length){
      operatorRegEx = `${Object.keys(selectedFilters.operator).sort(sortByLowerCase).join("|")}:`;
   }else{
             //default condition
    operatorRegEx = defaultRegEx;
   }
    if(selectedFilters.departureTime.length){
      departureTimeRegEx = `.*?(${selectedFilters.departureTime.join("|")}).*?:`;
      }else{
        //default condition
        departureTimeRegEx = defaultRegEx;
    }
    if(selectedFilters.arrivalTime.length){
        arrivalTimeRegEx = `.*?(${selectedFilters.arrivalTime.join("|")}).*?:`;
    }else{
          //default condition
          arrivalTimeRegEx = defaultRegEx ;
    }
    if(selectedFilters.boardingPoint.length){
         bpRegEx = `.*?(${selectedFilters.boardingPoint.sort(sortByLowerCase).join("|")}).*?:`;
    }else{
            //default condition
          bpRegEx = defaultRegEx;  
    }
    if(selectedFilters.droppingPoint.length){
       dpRegEx = `.*?(${selectedFilters.droppingPoint.sort(sortByLowerCase).join("|")}).*?:`;
    }else{
              //default condition
          dpRegEx = defaultRegEx;
    }

   if (selectedFilters.single_seat === true) {
     singleSeatRegEx = `.*?(ssa).*?:`
   } else {
     //default condition
     dpRegEx = defaultRegEx;
   }
   
   
   if(selectedFilters.amenities.length){
    amenitiesRegEx = `.*?(${selectedFilters.amenities.sort(sortByLowerCase).join("|")}).*?`;
 }else{
           //default condition
           amenitiesRegEx = '.*?';
 }                        
}
let regEx = new RegExp(popularRegEx + busTypeRegEx  + singleSeatRegEx + departureTimeRegEx + arrivalTimeRegEx + bpRegEx + dpRegEx  + operatorRegEx +amenitiesRegEx );
return regEx;
}



export function getFilterHash(item,popularFilters) {
  let filterHash = '';
  /**************************************************************************** */
  const isPopFilterPresent = item.pop_fil && item.pop_fil.length;
  if(popularFilters && popularFilters.length){
    for(let i in popularFilters){
      if(isPopFilterPresent && item.pop_fil.indexOf(popularFilters[i].k)!== -1){
        filterHash += `${popularFilters[i].k}:`
   
      }else{
        filterHash += ':';

      }
    }
   }
// if(item.pop_fil && item.pop_fil.length){
//   filterHash += `${item.pop_fil.join(":")}:`;

// }
// filterHash += ':';
  // const gpshash = item.fl[0].gps === 'false' ? '' : 'gps';
  // filterHash += gpshash;
  // filterHash += ':';
  // const otgHash = item.fl[0].ot ? 'otg' : '';
  // filterHash += otgHash;
  // filterHash += ':';
  // const reddealHash = Object.keys(item.reddeal).length ? 'reddeals' : '';
  // filterHash += reddealHash;

  let singleSeat = item?.fl[0]?.ssa;
  const amenities = item.amenities;
  let depT = parseInt(item.fl[0].dt.split(':')[0], 10);
  depT = (depT === 0 ? 24 : depT);
  let arrivalT = parseInt(item.fl[0].at.split(':')[0], 10);
  arrivalT = (arrivalT === 0 ? 24 : arrivalT);
  
  const rd = item.fl[0].rd;
  let seater = 0;
  let sleeper = 0;
  for (const i in rd) {
    const st = rd[i].seatType.toLowerCase();
    const stArr = st.split('/');
    for (let j in stArr) {
      if (stArr[j].indexOf('seater') !== -1 || stArr[j].indexOf('semi') !== -1) {
        seater = 1;
      }
      if (stArr[j].indexOf('sleeper') !== -1 && stArr[j].indexOf('semi') === -1) {
        sleeper = 1;
      }
    }

  }
//(sleeper):(seater|sleeper)
/**************************************************************************** */
let busType= []
let fanType= [];
if (item.fl[0].rd[0].busCondition === 'ac') {
  fanType.push('ac');
  }else{
    fanType.push('nonac');
  }
if(seater){
  busType.push('seater');  
}
if(sleeper){
  busType.push('sleeper');
}





//Note:- the order is key thing in regex so fanType should come before busType
if(fanType.length){
  filterHash += `${fanType.join("|")}:`;
 }
 

if(busType.length){
 filterHash += `${busType.join("|")}:`;
}

if(singleSeat){
  filterHash += `ssa:`
}

/**************************************************************************** */
if (depT >= 0 && depT < 6) {
  filterHash += '00-06';
} else if (depT >= 6 && depT < 12) {
  filterHash += '06-12';
} else if (depT >= 12 && depT < 18) {
  filterHash += '12-18';
} else {
  filterHash += '18-24';
}
filterHash += ':';
/**************************************************************************** */
// timeSlot
if (arrivalT >= 0 && arrivalT < 6) {
  filterHash += '00-06';
} else if (arrivalT >= 6 && arrivalT < 12) {
  filterHash += '06-12';
} else if (arrivalT >= 12 && arrivalT < 18) {
  filterHash += '12-18';
} else {
  filterHash += '18-24';
}
filterHash += ':';

/**************************************************************************** */
let bphash = '';
for (let index = 0; index < item.fl[0].bp.length; index++) {
  bphash += formatString(item.fl[0].bp[index].BPN) + '|';
}
filterHash += bphash;
filterHash += ':';

/**************************************************************************** */
let dphash = '';
for (let index = 0; index < item.fl[0].dp.length; index++) {
  dphash += formatString(item.fl[0].dp[index].DPN) + '|';
}
filterHash += dphash;
filterHash += ':';

/**************************************************************************** */
filterHash += item.op;
filterHash += ':';

/**************************************************************************** */
let amenitieshash = '';
for (let index = 0; index < amenities.length; index++) {
  amenitieshash += amenities[index] + '|';
}
filterHash += amenitieshash;
  return filterHash;
}
function getfilterVal(type,str){
  let arr= []
  if(str && str.length){
    arr = str.split("|");
  }
  return arr
}
export function getInitSelectedFilters(hardReset?:boolean) {
let popular = [],
busType= [],
departureTime= [],
arrivalTime= [],
boardingPoint= [],
droppingPoint= [],
operator= {},
amenities= [],
single_seat = false;
      
  if(typeof window != "undefined" && !hardReset){
 const searchString = window.location.search;
 const isFilter = getQueryString('isFilter',searchString);
 if(isFilter){

 const popularVal = getfilterVal('popular',getQueryString('popular',searchString));
 const busTypeVal =  getfilterVal('busType',getQueryString('busType',searchString));
 const departureTimeVal =  getfilterVal('departureTime',getQueryString('departureTime',searchString));
 const arrivalTimeVal =  getfilterVal('arrivalTime',getQueryString('arrivalTime',searchString));
 const boardingPointVal =  getfilterVal('boardingPoint',getQueryString('boardingPoint',searchString));
 const droppingPointVal =  getfilterVal('droppingPoint',getQueryString('droppingPoint',searchString));
 const operatorId = getQueryString('operatorId',searchString);
 const operatorName = getQueryString('operatorName',searchString);
 const operatorInfo = getfilterVal('operatorInfo',getQueryString('operatorInfo',searchString))
 const amenitiesVal =  getfilterVal('amenities',getQueryString('amenities',searchString));

let operatorObj ={}
if(operatorInfo && operatorInfo !== null && operatorInfo.length){
  for(let i in operatorInfo){
    let arr = operatorInfo[i].split("--");
    let opid = arr[0];
    let operatorName = arr[1];
    if(opid && operatorName){
      operatorObj[opid] = decodeURIComponent(operatorName)

    }
  }
}
 popular = popularVal !== null && popularVal && popularVal.length ? popularVal : [] 
 busType = busTypeVal !== null && busTypeVal && busTypeVal.length ? busTypeVal : [] 
 departureTime = departureTimeVal !== null && departureTimeVal && departureTimeVal.length ? departureTimeVal : [] 
 arrivalTime = arrivalTimeVal !== null && arrivalTimeVal && arrivalTimeVal.length ? arrivalTimeVal : [] 
 boardingPoint = boardingPointVal !== null && boardingPointVal && boardingPointVal.length ? boardingPointVal : [] 
 droppingPoint = droppingPointVal !== null && droppingPointVal && droppingPointVal.length ? droppingPointVal : [] 
 amenities = amenitiesVal !== null && amenitiesVal && amenitiesVal.length ? amenitiesVal : [] 
 operator =    operatorObj
 popular = popularVal !== null && popularVal && popularVal.length ? popularVal : [] 
 }
}
  return {
    popular,
    busType,
    departureTime,
    arrivalTime,
    boardingPoint,
    droppingPoint,
    operator,
    amenities,
    single_seat
  };
}

function sortByLowerCase(a: any, b: any) {
  return a.toLowerCase().localeCompare(b.toLowerCase());
}
